const PREFIX = 'corecry:avatar-snapshot:v1:';

export function readAvatarSnapshot(identity) {
    if (!identity) return '';
    try {
        const value = localStorage.getItem(PREFIX + identity) || '';
        return value.startsWith('data:image/') && value.length <= 250000 ? value : '';
    } catch { return ''; }
}

export async function writeAvatarSnapshot(identity, avatar, isCurrent) {
    if (!identity) return;
    try {
        if (!avatar) { localStorage.removeItem(PREFIX + identity); return; }
        if (!avatar.startsWith('data:image/')) return;
        const image = new Image();
        image.src = avatar;
        await image.decode();
        if (!isCurrent()) return;
        const scale = Math.min(1, 160 / Math.max(image.naturalWidth, image.naturalHeight));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
        canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
        const thumbnail = canvas.toDataURL('image/webp', 0.8);
        if (thumbnail.length <= 250000) localStorage.setItem(PREFIX + identity, thumbnail);
    } catch { /* An unavailable rendering cache must never block the profile. */ }
}

export function clearAvatarSnapshots() {
    try {
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key?.startsWith(PREFIX)) localStorage.removeItem(key);
        }
    } catch { /* Storage is optional. */ }
}
